<template>
	<v-card class="pa-2" color="#f9e7ff">
		<div v-if="loading">
			<v-progress-linear class="mt-3" color="primary" height="4" indeterminate rounded></v-progress-linear>
			<v-alert type="warning" icon="mdi-timer-sand" outlined>
				در حال دریافت اطلاعات...
			</v-alert>
		</div>
		<div v-else>
			<v-alert v-if="errorMessage" type="error" icon="mdi-shield-lock-outline" outlined>
				{{ errorMessage }}
			</v-alert>
			<div v-else>
				<div style="padding: 10px;border-bottom: 1px dashed red;text-align: center;">
					<div>
						استعلام توان پرداخت اقساط شما از بانک:
					</div>
					<div class="red--text">
						<strong class="" style="font-size: 20pt;">{{ String(credit).toPriceFormat() }} </strong>
						تومان
					</div>
				</div>
				<div class="red--text text-center py-3">
					لطفا ابتدا از لیست زیر، مدت بازپرداخت را انتخاب نمایید:
				</div>
				<v-item-group active-class="primary">
					<div class="d-flex flex-wrap">
						<v-item v-slot="{ active, toggle }" v-for="month in months" :key="month">
							<v-card @click="() => { test(calcMaxAmount(month), month); toggle() }" class="rounded-xl pa-2 d-flex mx-1 mb-1" :color="`${active ? 'pink lighten-4' : 'white lighten-3'}`" elevation="0">
								<v-avatar color="#eee" x-large>
									<div>{{ month }}</div>
									<br />
									<div>ماهه</div>
								</v-avatar>
								<div class="text-center">
									<div>حداکثر مبلغ خرید:</div>
									<div class="red--text">{{ String(calcMaxAmount(month)).toPriceFormat() }} <small>تومان</small></div>
								</div>
							</v-card>
						</v-item>
					</div>
				</v-item-group>
			</div>
		</div>

		<confirm-dlg ref="confirm" />
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'

	export default {
		name: 'RefahBetaManager',
		props: {
			nationalCode: { type: String, default: '' },
			loan: { type: Object, default: null }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				loading: false,
				errorMessage: '',
				credit: 5000000
			}
		},
		computed: {
			...get('memberAppSettings', [
				'icePrice',
			]),
			months() {
				return this.loan?.allowedInstallments ? this.loan.allowedInstallments.split(',').filter(x => x) : []
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.post('member/UserRefahBeta/GetInquiry/' + this.nationalCode, null)
					.then(
						response => {
							this.credit = response
						})
					.catch(err => {
						this.errorMessage = err.message
						this.$emit('update', null)
					})
					.finally(x => {
						this.loading = false
					})
			},
			update(updatedVal) {

			},
			test(max, month) {
				this.$emit('update', { max, month: Number(month), credit: this.credit })
			},
			calcMaxAmount(month) {
				if (!this.loan || !this.credit || !month)
					return 0

				let max = (this.credit * month) / (1 + ((month * this.loan.profitPercent) / 100))
				max = Math.round(max)
				return max
			}
		}
	}
</script>
<style scoped>
	.pattern-tags {
		list-style: none;
	}

	.pattern-tags li {
		display: inline;
		margin: 3px;
		color: blueviolet;
	}

	.link {
		text-decoration: none;
		font-size: 11px;
		padding: 3px;
		border-radius: 5px;
		border: 1px solid grey;
		margin-bottom: 3px;
		text-align: center;
	}
</style>
